// extracted by mini-css-extract-plugin
export default {"header":"Header_header__+q3o8","topBar":"Header_topBar__OH+8-","pageTitleText":"Header_pageTitleText__kynCG"};